module.exports = __webpack_public_path__ + "static/img/Sharpay_h5.9e44ceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/Sharpay_h5.png
// module id = ccpH
// module chunks = 34